import Event = createjs.Event;

export class HTTPStatusEvent extends Event {

    public static readonly HTTP_STATUS: string = "httpStatus";
    public static readonly HTTP_RESPONSE_STATUS: string = "httpResponseStatus";

    constructor(public type: string, public bubbles: boolean = false, public cancelable: boolean = false, public readonly status: number = 0, public redirected: boolean = false) {
        super(type, bubbles, cancelable);
    }

    public clone(): HTTPStatusEvent {
        return new HTTPStatusEvent(this.type, this.bubbles, this.cancelable, this.status, this.redirected);
    }
}
